import './lead_widget.scss'
import '../../borrower_widget.scss'
import {BorrowerWidget} from "../../borrowerWidget";
import {Lead} from "../../../../../lead/model/Lead";

export class LeadWidget {
    static instance = BorrowerWidget.wrapperInstanceFactory({
        controller: [LeadWidget],
        template: require('./lead_widget.html')
    })

    private contact: Lead;

}